<template>
  <b-modal id="deleteCategoryModal" centered :modal-class="modal_class">
    <div class="d-block mb-4">
      <input id="category_id" name="category_id" type="hidden" v-model="category_id" />

      <input id="client" name="client" type="hidden" v-model="client_name" />
      <p class="confirmMessageModalP my-4" :class="confirm_message_class" v-if="media_type == 'music_library'">
        Are you sure you want to delete this playlist?
      </p>
      <p class="confirmMessageModalP my-4" :class="confirm_message_class" v-else>
        Are you sure you want to delete this category?
      </p>
    </div>
    <template class="justify-content-center mt-5" #modal-footer>
      <b-row class="justify-content-center w-100">
        <b-col lg="4" md="6" class="text-center">
          <b-button type="button" :variant="btn_variant_primary" class="w-100 btn-bumblebee " :class="btn_submit_class"
            v-if="!is_loading" @click="clickConfirmDelete">
            Yes
          </b-button>
          <b-button type="button" disabled :variant="btn_variant_primary" class="btn-bumblebee w-100"
            :class="btn_submit_class" v-else>
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col>

        <b-col lg="4" md="6" class="text-center">
          <b-button type="button" :variant="btn_danger_outline_class" class="w-100 btn-bumblebee "
            :class="btn_submit_class" @click="closeModalDelete">
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
import $ from "jquery";
import axios from "axios";

export default {
  name: "DeleteCategory",
  props: ["client_name", "category_id", "media_type", "sub_media_type",
    "modal_class", "confirm_message_class", "btn_submit_class", "btn_variant_primary",
    "btn_danger_outline_class","swal_confirm_button_class","swal_container_class" ],

  data() {
    return {
      is_loading: false,
    };
  },

  mounted() { },

  methods: {
    clickConfirmDelete() {
      console.log(
        "in confirm delete category ",
        this.client_name,
        this.category_id
      );
      // return;
      this.is_loading = true;

      axios
        .post(
          "category/delete",
          { id: this.category_id },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: this.client_name,
              Authorization:
                "Bearer " +
                JSON.parse(window.localStorage.getItem("user")).access_token,
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.is_loading = false;
          let success_message = response.data.success
          if (this.media_type == "music_library") {
            success_message = success_message.replace("Category", "Playlist").replace("category", "playlist")
          }

          this.$fire({
            // title: "Title",
            text: success_message,
            type: "success",
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
            // timer: 5000,
          }).then((r) => {
            this.$bvModal.hide("deleteCategoryModal");
            console.log(this.media_type, this.sub_media_type)
            if (this.media_type == "video_library") {
              this.$parent.getMediaCategoryList();
            } else if (
              this.media_type == "meditation_library" &&
              this.sub_media_type == "video"
            ) {
              console.log(this.$parent);
              this.$parent.$refs.videoCategoryListMed.getMediaCategoryList();
            } else if (
              this.media_type == "meditation_library" &&
              this.sub_media_type == "audio"
            ) {
              console.log(this.$parent);
              this.$parent.$refs.audioCategoryListMed.getMediaCategoryList();
            }
            else if (
              this.media_type == "music_library"
            ) {
              console.log(this.$parent);
              this.$parent.getMediaCategoryList();
            }
          });

          // console.log("test3")
        })
        .catch((error) => {
          // console.log(error.response.data.error);
          // console.log(error.request);
          // console.log(error.message);
          this.is_loading = false;
          let error_message = error.response.data.error
          if (this.media_type == "music_library") {
            error_message = error_message.replace("Category", "Playlist").replace("category", "playlist")
          }

          this.$fire({
            // title: "Title",
            text: error_message,
            type: "error",
            // timer: 5000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r);
            // console.log(r.value);
          });
          // this.$parent.getUserList()
          // this.loginErrorMessage = error.response.data.error;
          // this.showLoginErrorMessage = true;
        });
    },
    closeModalDelete() {
      this.$bvModal.hide("deleteCategoryModal");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/media_components/media/DeleteCategory.vue